import { render, staticRenderFns } from "./SavingsPocketSetup.vue?vue&type=template&id=14ca51fa&scoped=true&"
import script from "./SavingsPocketSetup.vue?vue&type=script&lang=js&"
export * from "./SavingsPocketSetup.vue?vue&type=script&lang=js&"
import style0 from "./SavingsPocketSetup.vue?vue&type=style&index=0&id=14ca51fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca51fa",
  null
  
)

export default component.exports